export default __webpack_public_path__ + "static/media/slider1.e5a30fbe.jpg";